<script>
  import { Icon, Clipboard, CheckCircle } from "svelte-hero-icons";

  export let text = "";
  export let label = "Copy";

  let copied = false;
  let timeout;

  function copy() {
    navigator.clipboard.writeText(String(text)).then(() => {
      copied = true;
      clearTimeout(timeout);
      timeout = setTimeout(() => (copied = false), 2000);
    });
  }
</script>

<button
  on:click={copy}
  aria-label={label}
  class="hover:opacity-70 focus:outline-none {$$props.class || ''}"
>
  <Icon
    src={copied ? CheckCircle : Clipboard}
    class={copied ? "h-4 w-4 text-green-500" : "h-4 w-4"}
  />
</button>
